"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _concept = _interopRequireDefault(require("./concept"));
var _deck = _interopRequireDefault(require("./deck"));
var _tree_node_concept = _interopRequireDefault(require("./tree_node_concept"));
var _tree_node_deck = _interopRequireDefault(require("./tree_node_deck"));
var _tree_node_grammar_concept = _interopRequireDefault(require("./tree_node_grammar_concept"));
var _image = _interopRequireDefault(require("./image"));
var _word_type = _interopRequireDefault(require("./word_type"));
var _level = _interopRequireDefault(require("./level"));
var _deck_rulebook = _interopRequireDefault(require("./deck_rulebook"));
var _serializer_helpers = require("./utils/serializer_helpers");
var _static_date_decorator = _interopRequireDefault(require("./static_date_decorator"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TreeNode = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_deck_rulebook["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_tree_node_deck["default"]))), _dec4 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec5 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_word_type["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_concept["default"]))), _dec9 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_deck["default"]))), _dec0 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_tree_node_concept["default"]))), _dec1 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_tree_node_grammar_concept["default"]))), _dec10 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_concept["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function TreeNode() {
    var _this;
    _classCallCheck(this, TreeNode);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TreeNode, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "treeId", _descriptor2, _this);
    _initializerDefineProperty(_this, "treeModuleId", _descriptor3, _this);
    _initializerDefineProperty(_this, "treeRowId", _descriptor4, _this);
    _initializerDefineProperty(_this, "treeNodeType", _descriptor5, _this);
    _initializerDefineProperty(_this, "treeName", _descriptor6, _this);
    _initializerDefineProperty(_this, "treePosition", _descriptor7, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor8, _this);
    _initializerDefineProperty(_this, "treeNodeDecksCount", _descriptor9, _this);
    _initializerDefineProperty(_this, "treeNodeConceptsCount", _descriptor0, _this);
    _initializerDefineProperty(_this, "publishedSentencesCount", _descriptor1, _this);
    _initializerDefineProperty(_this, "openAccessSentencesCount", _descriptor10, _this);
    _initializerDefineProperty(_this, "grammarTipsCount", _descriptor11, _this);
    _initializerDefineProperty(_this, "hasGrammarDescription", _descriptor12, _this);
    _initializerDefineProperty(_this, "position", _descriptor13, _this);
    _initializerDefineProperty(_this, "name", _descriptor14, _this);
    _initializerDefineProperty(_this, "shortName", _descriptor15, _this);
    _initializerDefineProperty(_this, "webPublished", _descriptor16, _this);
    _initializerDefineProperty(_this, "mobilePublished", _descriptor17, _this);
    _initializerDefineProperty(_this, "rating", _descriptor18, _this);
    _initializerDefineProperty(_this, "grammarTitle", _descriptor19, _this);
    _initializerDefineProperty(_this, "translatedGrammarTitle", _descriptor20, _this);
    _initializerDefineProperty(_this, "openAccess", _descriptor21, _this);
    _initializerDefineProperty(_this, "descriptionMd", _descriptor22, _this);
    _initializerDefineProperty(_this, "grammarDescriptionMd", _descriptor23, _this);
    _initializerDefineProperty(_this, "grammarDescription", _descriptor24, _this);
    _initializerDefineProperty(_this, "grammarDescriptionTitle", _descriptor25, _this);
    _initializerDefineProperty(_this, "lastWebTriviaPublishedAt", _descriptor26, _this);
    _initializerDefineProperty(_this, "lastMobileTriviaPublishedAt", _descriptor27, _this);
    _initializerDefineProperty(_this, "grammarDescriptionOverride", _descriptor28, _this);
    _initializerDefineProperty(_this, "level", _descriptor29, _this);
    _initializerDefineProperty(_this, "deckRulebook", _descriptor30, _this);
    _initializerDefineProperty(_this, "treeNodeDecks", _descriptor31, _this);
    _initializerDefineProperty(_this, "webPublishedAt", _descriptor32, _this);
    _initializerDefineProperty(_this, "mobilePublishedAt", _descriptor33, _this);
    _initializerDefineProperty(_this, "image", _descriptor34, _this);
    _initializerDefineProperty(_this, "wordType", _descriptor35, _this);
    _initializerDefineProperty(_this, "concepts", _descriptor36, _this);
    _initializerDefineProperty(_this, "decks", _descriptor37, _this);
    _initializerDefineProperty(_this, "treeNodeConcepts", _descriptor38, _this);
    _initializerDefineProperty(_this, "treeNodeGrammarConcepts", _descriptor39, _this);
    _initializerDefineProperty(_this, "grammarConcepts", _descriptor40, _this);
    return _this;
  }
  _inherits(TreeNode, _RootModel);
  return _createClass(TreeNode, [{
    key: "webPublishedInLastWeek",
    get: function get() {
      return (0, _utils.isPresent)(this.webPublishedAt) && (0, _moment["default"])(this.webPublishedAt.date).add(1, 'week') > new Date();
    }
  }, {
    key: "daysSinceLastTriviaUpdate",
    get: function get() {
      var dateObj = new _static_date_decorator["default"](this.lastWebTriviaPublishedAt);
      return dateObj.daysSince;
    }
  }, {
    key: "nameAndTreeNameAndDeckCount",
    get: function get() {
      return "".concat(this.name, " - ").concat(this.treeName, " - ").concat(this.treeNodeDecksCount, " decks");
    }
  }, {
    key: "allDecksHaveGrammarDescriptionOverride",
    get: function get() {
      return (0, _lodash.every)(this.treeNodeDecks.map(function (item) {
        var _item$deck;
        return (_item$deck = item.deck) === null || _item$deck === void 0 ? void 0 : _item$deck.grammarDescriptionOverride;
      }));
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "treeId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "treeModuleId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "treeRowId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "treeNodeType", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "treeName", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "treePosition", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "treeNodeDecksCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "treeNodeConceptsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "publishedSentencesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "openAccessSentencesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "grammarTipsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "hasGrammarDescription", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "position", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "name", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "shortName", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "webPublished", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "mobilePublished", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "rating", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "grammarTitle", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "translatedGrammarTitle", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "openAccess", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "descriptionMd", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionMd", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "grammarDescription", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionTitle", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "lastWebTriviaPublishedAt", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "lastMobileTriviaPublishedAt", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionOverride", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "level", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "deckRulebook", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "treeNodeDecks", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "webPublishedAt", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "mobilePublishedAt", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "image", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "wordType", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "concepts", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "decks", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "treeNodeConcepts", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "treeNodeGrammarConcepts", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "grammarConcepts", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _class);
var _default = exports["default"] = TreeNode;